<template>
  <ConfirmationModal
    :entity="buyer"
    :title="$t('DELETE_BUYER_MODAL_TITLE')"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('DELETE')"
    :confirm-button-loading="loadingDeletingBuyer"
    :show-cancel-button="showActions"
    :show-confirm-button="showActions"
    @confirm="confirmDelete"
    @close="closeDeleteModal"
  >
    <div v-if="!buyerReferences">
      <Loader v-if="loadingBuyerReferences" custom-class="size-sm" />
      <span v-html="$t(checkReferencesText, { buyerName: buyer.name })"></span>
    </div>

    <p
      v-if="buyerReferences && !buyerReferences.hasReferences"
      v-html="
        $t('DELETE_BUYER_MODAL_NONE_ASSOCIATION_TEXT', {
          buyerName: buyer.name,
        })
      "
    ></p>

    <div v-if="buyerReferences && buyerReferences.hasReferences">
      <p
        v-html="
          $t('DELETE_BUYER_MODAL_ASSOCIATION_TEXT', { buyerName: buyer.name })
        "
      ></p>

      <div class="well well-sm m-t-10 m-b-0">
        <div class="form-horizontal">
          <div
            class="row"
            v-if="
              buyerReferences.ringbausers && buyerReferences.ringbausers.length
            "
          >
            <label class="col-md-3 control-label">
              <strong>Users</strong>
            </label>
            <div class="col-md-8">
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li v-for="(user, index) in buyerReferences.ringbausers">
                  <span class="display-text" :title="user.ringbauserName">
                    {{ user.ringbauserName }}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="row"
            v-if="buyerReferences.targets && buyerReferences.targets.length > 0"
          >
            <label class="col-md-3 control-label">
              <strong>Targets</strong>
            </label>
            <div class="col-md-8">
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li v-for="(target, index) in buyerReferences.targets">
                  <a
                    v-tooltip.right.hover="$t(target.targetEditTooltip)"
                    :href="getTargetHref(target)"
                    target="_blank"
                  >
                    <span class="display-text" :title="target.targetName">
                      {{ target.targetName }}
                    </span>
                    <i class="fa fa-external-link m-l-5"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import Loader from '@/core/components/Loader';
import sharedMessages from '@/core/locales';
import messages from '../locales';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'BuyerDeleteModal',
  components: {
    ConfirmationModal,
    Loader,
  },
  props: {
    buyer: {
      type: Object,
      default: function () {
        return {};
      },
    },
    buyerReferences: {
      type: Object,
      default: function () {
        return {};
      },
    },
    loadingDeletingBuyer: {
      type: Boolean,
      default: false,
    },
    loadingBuyerReferences: {
      type: Boolean,
      default: false,
    },
    checkReferencesText: {
      type: String,
      default: '',
    },
  },

  computed: {
    showActions() {
      return !!this.buyerReferences;
    },
  },

  methods: {
    confirmDelete(buyer) {
      this.$emit('confirm', buyer);
    },
    closeDeleteModal() {
      this.$emit('close');
    },
    getTargetHref(target) {
      return $ngStateService.href(
        target.targetEdit.targetStateName,
        target.targetEdit.targetStateParams,
        { absolute: true }
      );
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>